import React from 'react';

const AlignLeftChunkySvg = (props) => (
    <svg
        className="align-left-chunky_svg__eds-icon--align-left-chunky_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="align-left-chunky_svg__eds-icon--align-left-chunky_bottom"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 17h16v2H4v-2z"
        />
        <path
            className="align-left-chunky_svg__eds-icon--align-left-chunky_middle"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 11h8v2H4z"
        />
        <path
            className="align-left-chunky_svg__eds-icon--align-left-chunky_top"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 5h16v2H4z"
        />
    </svg>
);

AlignLeftChunkySvg.displayName = 'AlignLeftChunkySvg';
export default AlignLeftChunkySvg;
